import { getSpeakers, getSpeakerDetails } from '../../../utils/services';
import { fetchTalksSuccess } from '../../Program/actions/programActions';

export const FETCH_SPEAKERS_SUCCESS = 'FETCH_SPEAKERS_SUCCESS';
export const FETCH_SPEAKERS_REQUEST = 'FETCH_SPEAKERS_REQUEST';

const fetchSpeakersRequest = () => ({
    type: FETCH_SPEAKERS_REQUEST
});

export const fetchSpeakersSuccess = payload => ({
    type: FETCH_SPEAKERS_SUCCESS,
    payload
});

export const fetchSpeakerDetails = id => async dispatch => {
    dispatch(fetchSpeakersRequest());
    try {
        const data = await getSpeakerDetails(id);
        dispatch(fetchSpeakersSuccess(data.speakers));
        dispatch(fetchTalksSuccess(data.talks));
    } catch (error) {
        dispatch(fetchSpeakersSuccess([]));
    }
};

export const fetchSpeakers = () => async dispatch => {
    dispatch(fetchSpeakersRequest());
    try {
        const speakers = await getSpeakers();
        dispatch(fetchSpeakersSuccess(speakers));
    } catch (error) {
        dispatch(fetchSpeakersSuccess([]));
    }
};
